<div *ngIf="nonProd" class="alert alert-info alert-dismissible rounded-0 m-0" role="alert">
  You are in a non-production environment. This message will not appear in production.
  <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
</div>

<div class="display-container light-theme">
  <!-- START AUTHENTICATING -->
  <div *ngIf="isLoading" class="loading-screen-container">
    <app-loading-screen></app-loading-screen>
  </div>
  <!-- END AUTHENTICATING -->

  <!-- START NOT AUTHENTICATED -->
  <div *ngIf="isUnAuthenticated" class="login-screen-container">
    <app-login-screen></app-login-screen>
  </div>
  <!-- END NOT AUTHENTICATED -->

  <!-- START AUTHENTICATED -->
  <div *ngIf="isAuthenticated" class="authenticated-screen-container">
    <app-navbar></app-navbar>
    <app-side-nav class="side-nav"></app-side-nav>
  </div>
  <!-- END AUTHENTICATED -->
</div>